import { EditorView } from '@codemirror/view';

/**
 * Base theme for CodeEditor that integrates with ui-web styling
 * Uses CSS custom properties for consistent theming
 */
export const uiWebBaseTheme = EditorView.baseTheme({
  '&': {
    fontSize: '14px',
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  },
  '.cm-content': {
    padding: '8px 12px',
    caretColor: 'rgb(var(--color-primary))',
  },
  '&.cm-focused': {
    outline: 'none',
  },
  '.cm-cursor, .cm-dropCursor': {
    borderLeftColor: 'rgb(var(--color-primary))',
  },
  '.cm-activeLine': {
    backgroundColor: 'rgb(var(--color-neutral) / 0.03)',
  },
  '.cm-activeLineGutter': {
    backgroundColor: 'rgb(var(--color-neutral) / 0.05)',
  },
  '.cm-gutters': {
    backgroundColor: 'rgb(var(--color-neutral) / 0.02)',
    borderRight: '1px solid rgb(var(--color-neutral) / 0.1)',
    color: 'rgb(var(--color-neutral) / 0.4)',
  },
  '.cm-lineNumbers .cm-gutterElement': {
    padding: '0 8px 0 4px',
  },
  '.cm-placeholder': {
    color: 'rgb(var(--color-neutral) / 0.4)',
    fontStyle: 'italic',
  },
  '.cm-tooltip': {
    backgroundColor: 'white',
    border: '1px solid rgb(var(--color-neutral) / 0.2)',
    borderRadius: '6px',
    boxShadow:
      '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
  '.cm-tooltip-autocomplete': {
    '& > ul': {
      maxHeight: '200px',
    },
    '& > ul > li': {
      padding: '4px 8px',
    },
    '& > ul > li[aria-selected]': {
      backgroundColor: 'rgb(var(--color-primary) / 0.1)',
      color: 'rgb(var(--color-primary))',
    },
  },
  '.cm-completionLabel': {
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  },
  '.cm-completionDetail': {
    marginLeft: '8px',
    fontStyle: 'italic',
    color: 'rgb(var(--color-neutral) / 0.6)',
  },
  '.cm-completion-variable-icon': {
    fontFamily:
      'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    fontSize: '10px',
    color: 'rgb(var(--color-primary))',
    marginRight: '4px',
  },
});

/**
 * Theme for disabled state
 */
export const uiWebDisabledTheme = EditorView.theme({
  '&': {
    backgroundColor: 'rgb(var(--color-neutral) / 0.05)',
    cursor: 'not-allowed',
  },
  '.cm-content': {
    color: 'rgb(var(--color-neutral) / 0.5)',
  },
});

/**
 * Theme for invalid/error state
 */
export const uiWebInvalidTheme = EditorView.theme({
  '&': {
    borderColor: 'rgb(var(--color-failure))',
  },
  '&.cm-focused': {
    boxShadow: '0 0 0 3px rgb(var(--color-failure) / 0.2)',
  },
});
